<template>
    <!-- 表格展示-->
    <div>
      <el-table :data="result.tableData" ref="table" style="width: 100%;" class="indicatorTable"  
      max-height="400px" size="small" highlight-current-row :cell-class-name="cellBg" @header-click="headerClick"
      :header-cell-style="{background:'#D0E8F3'}">
        <el-table-column type='index' align="center" fixed label="序号" width="50"></el-table-column>
        <el-table-column align="center" fixed width="140" v-for="item in result.tableProp" :prop="item.prop" :label="item.label" :key="item.id"></el-table-column>
        <el-table-column align="center"  v-for="(item,index) in result.tableProp2" :label="item.label" :key="index">
          <el-table-column align="center" v-for="(item,index) in item.child" :label="item.label" :prop="item.prop" :key="index" width="90px"></el-table-column>
        </el-table-column>
      </el-table>
    </div>
</template>

<script>
export default {
    name: "HcTable",
    props:{
        //表头数据
      lazyLoad:{
        type:Boolean,
        default:false
      },
      height:{
        type: Number | String,
        default:false
      },
      chartType: {
        type: Array
      },
      result: {
        type: Object
      },
    },
    data() {
      return {
        loading:true,
        paramsData:{},
        pageSize: 10,
        currentPage:1, //页码
        total: 0,      //总条数
        fitHeight: this.height,
        radio:'',
        chartData: {},
        columnIndex: []
      }
    },
    mounted() {
      let _this = this;
      if (!this.lazyLoad) {
      }
      this.fit();
      window.onresize = () => {
        return (() => {
          this.fit();
        })()
      }
      this.defaultFn();  
    },
    methods: {
        fit() {
            this.fitHeight = this.$parent.$el.offsetHeight - (this.$el.offsetTop - this.$parent.$el.offsetTop) - 60;
        },
        // 首次加载默认选择第一大列
        defaultFn() {
          let _this = this;
          if (_this.result.tableProp2 && _this.result.tableProp2.length > 0) {
            let columns = this.$refs.table.columns;
            let l = _this.result.tableProp2[0].child.length;
            for (let i = 0; i < l; i++) {
              columns[2+i].level = '2'; // 从第2列开始添加level
              _this.headerClick(columns[2+i]);
              // columns[3].level = '2';
            }
            /* _this.headerClick(columns[2]); 
            _this.headerClick(columns[3]);  */
          }
        },
        cellBg({row, column, rowIndex, columnIndex}) {
          if (this.columnIndex.includes(columnIndex)) {
            return 'columnBg';
          }
        },
        // 改变背景色
        changeBgc(column){
          let _this = this;
          column.forEach(t=>{
            // 获取当前列的列数，为设置背景色所用
            let property = t.property;
            if (_this.result.tableData.length > 0) {
              let keys = Object.keys(_this.result.tableData[0]);
              let v = keys.indexOf(property) + 1; // 当前列的列数
              let index = _this.columnIndex.indexOf(v); // 当前列是否已经选中
              if (index>-1) { //已选中则删除
                _this.columnIndex.splice(index,1);
              } else { // 否则添加
                _this.columnIndex.push(v);
              }
            }
          })
        },
        headerClick(column, event){
          let _this = this;
          if (column.label == '序号' || _this.result.tableProp[0].prop == column.property){
            return;
          }
          if (column.level == '1') {
            _this.changeBgc(column.children);
            _this.putChartData(column.children,column.label);
          } else if(column.level == '2'){
            let columns = [];
            columns.push(column);
            _this.changeBgc(columns);
            _this.putChartData(columns);
          }
        },
        // 整合图表数据
        putChartData(column,label) {
          let _this = this;
           // x轴数据
          let xprop = _this.result.tableProp[0]['prop'];          
          column.forEach(t=>{
            let prop = t.property; // 如：v2
            let index = prop.substring(1) // 截取属性的数字部分，即图表类型的index
            let chartType = _this.chartType[index]; // 获取chartType
            let legend = label; // 一级列的名称
            // let legend = t.label;
            // 如果点击的是二级列，需要获取一级列的label
            if (!label) {
              let tprop = _this.result.tableProp2;
              outer: 
              for (let i=0;i<tprop.length;i++) {
                inner: 
                for (let j=0;j<tprop[i].child.length;j++) {
                  if (t.property == tprop[i].child[j].prop) {
                    legend = tprop[i].label;
                    break outer;
                  }
                }
              }
            }
            let ydata = []; // 渲染的数据
            _this.result.tableData.forEach(e => {
              for (let i in e) {
                if (i == prop) {
                  ydata.push(e[i]);
                }
              }
            });
            let xdata = [];
            _this.result.tableData.forEach(e => {
            for (let i in e) {
              if (i == xprop) {
                xdata.push(e[i]);
              }
            }
            });
            if (this.chartData[prop]) {
              delete this.chartData[prop];
            } else {
              // let name = label ? label+t.label : t.label;
              this.chartData[prop] = {
                prop: prop,
                type: chartType,
                data: ydata.reverse(),
                legend: legend+t.label,
                xdata: xdata.reverse(),
                name: legend+t.label
              };
            }
          })
          for (let i in this.chartData) {
            if(this.chartData[i].type == 'line') {
              this.chartData[i].yAxisIndex = 1;
              this.chartData[i].symbol = 'none';
            }
            if (this.chartData[i].type == 'bar') {
              this.chartData[i].barMaxWidth = 20;
            }
          }
          /* if (Object.keys(this.chartData).length > 1) {
            this.chartData.value2.yAxisIndex = 1;
          } */
          this.$emit('renderChart', this.chartData);
        },
    }
}
</script>

<style>
.indicatorTable{
  border: 1px solid rgb(200, 204, 214);
}
.indicatorTable.el-table td, 
.indicatorTable.el-table th,
.indicatorTable.el-table th.is-leaf{
  /* border-color: #A3A9B5; */
  border-color: rgb(200, 204, 214);
}
.el-table tr .columnBg{
    background: #e2e7f3;
}
</style>


// WEBPACK FOOTER //
// src/components/table.vue